import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setCheckWallet, setConfirmWallet } from "../redux/actions/app";
import { closePopup } from "../redux/actions/modal";
import CrossCloseButton from "./parts/CrossCloseButton";

export default function () {
  const [confirmed, setConfirmed] = useState(false);
  const [wallet, setWallet] = useState(null);
  const [value, setValue] = useState("");
  const isCheck = useSelector((state) => state.modal.data?.isCheck);
  const dispatch = useDispatch();

  const confirmHandler = (e) => {
    e.preventDefault();

    const walValue = value.trim();

    if (walValue.trim() !== "") {
      setWallet(walValue);
      setValue("");
      setConfirmed(true);

      return;
    }
  };

  const approveHandler = (e) => {
    e.preventDefault();

    if (value.trim() !== wallet) {
      return;
    }

    if (isCheck === true) {
      dispatch(setCheckWallet({ bill: wallet }));
    } else {
      dispatch(setConfirmWallet({ bill: wallet }));
    }

    return dispatch(closePopup());
  };

  return (
    <div className="modal modal_w308 modal-wallet">
      <div className="modal-wallet__close-window">
        <CrossCloseButton />
      </div>
      <div className="modal-wallet__logo">
        <img src="/assets/images/page-icons/round-mark.svg" alt="wallet" />
      </div>
      <form className="modal-form modal-wallet-form">
        <div className="modal-form__field modal-wallet__field">
          <div className="modal-wallet-form__icon">
            <img src="/assets/images/page-icons/wallet.svg" alt="wallet" />
          </div>
          <input
            type="text"
            name="wallet"
            className="modal-wallet__input"
            placeholder="Your wallet..."
            value={value}
            onChange={(e) => setValue(e.target.value)}
          />
        </div>
        {confirmed === false ? (
          <button
            className="custom-button modal-wallet__btn"
            onClick={confirmHandler}
          >
            <span>CONFIRM</span>
          </button>
        ) : (
          <button
            className="custom-button modal-wallet__btn"
            onClick={approveHandler}
          >
            <span>Approve</span>
          </button>
        )}
      </form>
    </div>
  );
}
